import { ReportInterface } from '../../../interfaces/report.interface';

export class UpdateReport {
    public static readonly type = '[JobsPlacements] update report';

    constructor(public report: ReportInterface) {}
}
